module.exports = __webpack_public_path__ + "img/ET311.0284dc60.png";